// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"64":"91bb1170","180":"0a72c2d7","203":"3b7fa2e7","232":"cf003ddb","299":"e4191961","321":"bdf4d7e6","379":"aeca3771","388":"b21a4938","435":"fa05be3c","520":"cb79343f","530":"ddfb5b7d","654":"7b582351","779":"1926be52","895":"f88f72b3"}[chunkId] + ".chunk.js";
};